module.exports = __webpack_public_path__ + "img/canbadge_daishi_90_110mm_line.40215980.png";